import ServicePageTemplate from "@/components/layout/ServicePageTemplate";

export default function HVACPage() {
  return (
    <div data-testid="hvac-page">
      <ServicePageTemplate
        overline="HVAC"
        title="Heating & cooling — comfort, efficiency, all year."
        sub="Expert installation, maintenance and repair for residential and commercial systems — engineered for clean operation and energy efficiency."
        image="https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg"
        serviceTitle="HVAC"
        services={[
          "Air Conditioning Installation",
          "Furnace Repairs",
          "System Maintenance & Tune-Ups",
          "Thermostat Installation",
          "Ductwork Services & Upgrades",
          "Mini Split Systems",
          "Heat Pump Systems",
          "Commercial HVAC",
        ]}
        benefits={[
          "Experienced Technicians",
          "Reliable Scheduling",
          "Energy Efficient Solutions",
          "Quality Equipment",
          "Professional Installations",
          "Honest Service",
        ]}
        faq={[
          { q: "How often should HVAC be serviced?", a: "Twice a year is ideal — once in spring (cooling) and once in fall (heating). We offer maintenance programs." },
          { q: "Are mini-splits a good fit for ADUs?", a: "Yes — they're efficient, quiet and don't require ductwork. We install them frequently in ADU builds." },
          { q: "Do you replace ductwork?", a: "Absolutely. We assess airflow, seal leaks and replace damaged sections to improve efficiency and air quality." },
        ]}
      />
    </div>
  );
}
